// Styles
import '../scss/main.scss';

// Import asset images
import './images';

// Import javascript
// import debounce from './helpers/debounce';

import toastr from 'toastr';
import SmoothScroll from './partials/smoothScroll';
import cssVars from 'css-vars-ponyfill';

import siteMenu from './partials/siteMenu';
import cookies from './partials/cookies';
import sliders from './partials/sliders';
import videos from './partials/videos';
import lazyLoadVideo from './partials/videos';
import faq from './partials/faq';
import registerForm from './partials/registerForm';
import loginForm from './partials/loginForm';
import codeLoginForm from './partials/codeLoginForm';
import peopleGrid from './partials/peopleGrid';
import loadMoreCourseModules from './partials/loadMoreCourseModules';
import alerts from './partials/alerts';


  
document.addEventListener("DOMContentLoaded", function () {
    toastr.options = {
        "closeButton": false,
        "debug": false,
        "newestOnTop": false,
        "progressBar": true,
        "positionClass": "toast-bottom-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "2000",
        "timeOut": "5000",
        "extendedTimeOut": "2000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    }

    cssVars({});
    siteMenu();
    sliders();
    videos();
    cookies();
    faq();
    registerForm(toastr);
    loginForm();
    codeLoginForm();
    loadMoreCourseModules();
    peopleGrid();
    alerts(toastr);

    new SmoothScroll('a[href*="#"]', { header: '#header' });

    window.addEventListener('resize', function () {
        document.documentElement.style.setProperty('--vh', window.innerHeight * 0.01 + 'px');
    });
});



